export default "__VITE_ASSET__BO74VKLY__"